//#region imports

// react
import React, { useEffect, useState } from 'react';

// redux
import { useSelector, useDispatch } from 'react-redux';
import { selectShoppingCartPrice, selectShoppingCart } from 'redux/slices/marketplace/user-marketplace';

// stripe
import { loadStripe } from '@stripe/stripe-js';
import { Elements } from '@stripe/react-stripe-js';

// create stripe instance
//let publishableKey = 'pk_test_51RSxitRLJdB3UHboo2BDtpZd8kU29elwtuoYssQhN3Anebps5H4Oqntfua98mHagPRQdwzpxMjxmwRkz2tiNxWeq00d14t5hFx';     // publishable key for conor.thorne@prmassist.com account
//let testKey = 'pk_test_51JZMhZKZM1vasB44RhWi4G0b4uqpw8Oe1VUglC41ZeKEay597UPqZxbN4jPrh5U0j7Ta2h6qYzJwl53Y9ptQIHoC00TmghlxMq'
let prodKey = 'pk_live_51JZMhZKZM1vasB44SEcFRmU6DrlWO1KrrfsX0fcxduR1GQ093qS5I9gE9FbLr0xCDJEGjWgkRGvXvWVlq3bf4tgd005D7Pfai9';


// let websiteTestKey = 'pk_test_51RSy3t4JeMoDjVpODZhyOVrjw69RfQfkgKX2KCJdg35MSNmhgzoG0ZbGeYPyPTOxweCoCr6RtFHyFsM0BDfbs3zT00qEBFqahz'
const stripePromise = loadStripe(prodKey);

// custom components
import CheckoutInformation from './components/checkout-information';

//#endregion

const CheckoutPage = (props) => {
    const cart = useSelector(selectShoppingCart) || {};
    const amount = useSelector(selectShoppingCartPrice);

    const options = {
        mode: 'payment',
        amount: Math.round(amount * 100),
        currency: 'eur',
    };

    if (amount > 0 && Object.keys(cart).length > 0) {
        return (
            <Elements stripe={stripePromise} options={options}>
                <CheckoutInformation />
            </Elements>
        );
    }

    return (
        <div>
            <CheckoutInformation />
        </div>
    );

};

export default CheckoutPage;


